import { default as WcEthereumProvider } from '@walletconnect/ethereum-provider';
export class EthereumProvider extends WcEthereumProvider {
    static async initProvider(opts, persistStorePrefix) {
        const provider = new EthereumProvider(persistStorePrefix);
        await provider.initialize(opts);
        return provider;
    }
    constructor(persistStorePrefix) {
        super();
        this.persistStorePrefix = persistStorePrefix;
    }
    async connect(opts) {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type !== 'attributes' || mutation.attributeName !== 'theme')
                    return;
                this.modal.closeModal();
            });
        });
        try {
            const htmlElement = document.querySelector('html');
            observer.observe(htmlElement, { attributes: true });
            return await super.connect(opts);
        }
        finally {
            observer.disconnect();
        }
    }
    async initialize(opts) {
        this.rpc = this.getRpcConfig(opts);
        this.chainId = this.rpc.chains.length
            ? getEthereumChainId(this.rpc.chains)
            : getEthereumChainId(this.rpc.optionalChains);
        const storage = await WalletConnectStorage.init(this.persistStorePrefix);
        const { UniversalProvider } = await import('@walletconnect/universal-provider');
        this.signer = await UniversalProvider.init({
            projectId: this.rpc.projectId,
            metadata: this.rpc.metadata,
            disableProviderPing: opts.disableProviderPing,
            relayUrl: opts.relayUrl,
            storageOptions: opts.storageOptions,
            storage,
        });
        this.registerEventListeners();
        await this.loadPersistedSession();
        if (this.rpc.showQrModal) {
            let WalletConnectModalClass;
            try {
                const { WalletConnectModal } = await import('@walletconnect/modal');
                WalletConnectModalClass = WalletConnectModal;
            }
            catch {
                throw new Error('To use QR modal, please install @walletconnect/modal package');
            }
            if (WalletConnectModalClass) {
                try {
                    this.modal = new WalletConnectModalClass({
                        projectId: this.rpc.projectId,
                        ...this.rpc.qrModalOptions,
                    });
                }
                catch (e) {
                    this.signer.logger.error(e);
                    throw new Error('Could not generate WalletConnectModal Instance');
                }
            }
        }
    }
    async disconnect() {
        await super.disconnect().catch(() => {
            /* ignore */
        });
        await this.signer.disconnect().catch(() => {
            /* ignore */
        });
        await this.dropPersist().catch(() => {
            /* ignore */
        });
    }
    async dropPersist() {
        return this.signer.client.core.storage.dropStorage();
    }
}
export class WalletConnectStorage {
    static { this.instances = new Map(); }
    static async dropStorage(persistStorePrefix) {
        const storage = await WalletConnectStorage.init(persistStorePrefix);
        await storage.dropStorage();
    }
    static async dropStorageByName(name) {
        const storage = await WalletConnectStorage.init(name);
        await storage.dropStorage();
    }
    static getDatabaseName(persistStorePrefix) {
        return `wallet-connect-connection-storage-${persistStorePrefix}`;
    }
    static async init(persistStorePrefix) {
        if (!this.instances.has(persistStorePrefix)) {
            const instance = new WalletConnectStorage();
            await instance.init(WalletConnectStorage.getDatabaseName(persistStorePrefix));
            this.instances.set(persistStorePrefix, instance);
        }
        return this.instances.get(persistStorePrefix);
    }
    async init(name) {
        const DexieCtx = await import('dexie').then((m) => m.default);
        this.dexie = new DexieCtx(name);
        this.dexie.version(1).stores({
            data: ['key', 'value'].join(', '),
        });
        this.data = this.dexie.table('data');
        return this;
    }
    async dropStorage() {
        this.dexie.delete();
    }
    async getKeys() {
        const keys = await this.data.toCollection().keys();
        return keys;
    }
    async getEntries() {
        const entries = [];
        await this.data.each((data) => {
            entries.push([data.key, data.value]);
        });
        return entries;
    }
    async getItem(key) {
        return (await this.data.get(key).then((data) => data?.value));
    }
    async setItem(key, value) {
        await this.data.put({ key, value });
    }
    async removeItem(key) {
        await this.data.delete(key);
    }
}
export function getEthereumChainId(chains) {
    return Number(chains[0].split(':')[1]);
}
//# sourceMappingURL=ethereum-provider.js.map